import { Injectable } from '@angular/core'
import { Observable, switchMap, throwError } from 'rxjs'
import { selectCaseId } from '../../state/case/case.selectors'
import { StoreUtilsService } from './store-utils.service'
import { CaseId, MarkerDimension } from '../../state/case/case.state'
import { MarkerCatalogService } from './marker-catalog.service'

@Injectable({
    providedIn: 'root',
})
export class CaseUtilsService {
    constructor(
        private readonly storeUtils: StoreUtilsService,
        private readonly markerCatalog: MarkerCatalogService
    ) {}

    createObservableWithCaseId<T>(observableFn: (caseId: CaseId) => Observable<T>): Observable<T> {
        return this.storeUtils.snapshotObservable(selectCaseId).pipe(
            switchMap(caseId => {
                return caseId
                    ? observableFn(caseId)
                    : throwError(() => new Error('Could not determine dataset ID.'))
            })
        )
    }

    createObservableWithMarkerDimensions<T>(
        observableFn: (markerDimensions: MarkerDimension[]) => Observable<T>
    ): Observable<T> {
        return this.markerCatalog.getAllMarkers$().pipe(
            switchMap(markerDimensions => {
                return observableFn(markerDimensions)
            })
        )
    }
}
